import { message } from "antd";
import axios from "axios";

const serviceConfigs = {
    arc: {
        baseURL: process.env.REACT_APP_ITGC,
        headers: {
            "Accept-Language": "en",
        }
    },
    project: {
        baseURL: process.env.REACT_APP_PROJECT,
        headers: {
            "Accept-Language": "en",
        }
    },
    framework: {
        baseURL: process.env.REACT_APP_FRAMEWORK,
        headers: {
            "Accept-Language": "en",
        }
    },
    evidence: {
        baseURL: process.env.REACT_APP_EVIDENCE,
        headers: {
            "Accept-Language": "en",
        }
    },
    evaluation: {
        baseURL: process.env.REACT_APP_EVOLUTION,
        headers: {
            "Accept-Language": "en",
        }
    },
    report: {
        baseURL: process.env.REACT_APP_REPORT,
        headers: {
            "Accept-Language": "en",
        }
    },
}

const createAxiosInstance = (config) => {
    const instance = axios.create({
        baseURL: config.baseURL,
        headers: config.headers
    });

    instance.interceptors.request.use(
        function (axiosConfig) {
            const token = localStorage.getItem("ACCESS_TOKEN") || localStorage.getItem("RESET_TOKEN");
            if(token) {
                axiosConfig.headers.Authorization = `Bearer ${token}`
            }

            return axiosConfig;
        },
        function (error) {
            return Promise.reject(error);
        }
    )
    
    instance.interceptors.response.use(
        function (response) {
            return response;
        },
        async function (error) {
            if (error.response && error.response.status === 401) {
                const originalRequest = error.config;

                // Check if this is not already a retry request
                if (!originalRequest._retry) {
                    originalRequest._retry = true;

                    const refreshToken = localStorage.getItem("REFRESH_TOKEN");
                    if (refreshToken) {
                        try {
                            // Attempt to refresh the token
                            const refreshResponse = await axios.post(
                                `${serviceConfigs.auth.baseURL}/auth/v1/user/refresh`,
                                {
                                    client_id: "ZYDPLLBWSK3MVQJSIYHB1OR2JXCY0X2C5UJ2QAR2MAAIT5Q",
                                    client_type: "web",
                                    token_type: "refresh",
                                },
                                {
                                    headers: {
                                        Authorization: `Bearer ${refreshToken}`,
                                    },
                                }
                            );

                            if (refreshResponse.data.status === 200) {
                                // Update the access token
                                localStorage.setItem("ACCESS_TOKEN", refreshResponse?.data?.data?.access?.token);
                                localStorage.setItem("userId", refreshResponse?.data?.data?.user_id);
                                
                                // Retry the original request with the new token
                                originalRequest.headers.Authorization = `Bearer ${refreshResponse?.data?.data?.access?.token}`;
                                return instance(originalRequest);
                            }
                            
                        } catch (refreshError) {
                            // Refresh failed, clear storage and redirect
                            localStorage.clear();
                            sessionStorage.clear();
                            message.error("Session expired. Please login again.");
                            
                            if (typeof window !== 'undefined') {
                                window.location.href = "/";
                            }
                        }

                    } else {
                        // No refresh token available, clear storage and redirect
                        localStorage.clear();
                        sessionStorage.clear();
                        message.error("Session expired. Please login again.");
                        
                        if (typeof window !== 'undefined') {
                            window.location.href = "/";
                        }
                    }
                }
            }
            return Promise.reject(error);
        }
    )

    return instance;
}

const axiosInstances = {};
Object.keys(serviceConfigs).forEach((serviceName) => {
    axiosInstances[serviceName] = createAxiosInstance(
        serviceConfigs[serviceName]
    );
});

export const GET = async (service, url, params, options) => {
  try {
    let result = await axiosInstances[service].get(url, { 
      params: params,
      ...options 
    });
    return result;
  } catch (error) {
    return error?.response;
  }
};

export const DELETE = async (service, url, params, data) => {
  try {
    let result = await axiosInstances[service].delete(url, { params, data });
    return result;
  } catch (error) {
    return error?.response;
  }
};

export const POST = async (service, url, body, options) => {
  try {
    let result = await axiosInstances[service].post(url, body, options);
    return result;
  } catch (error) {
    console.log(error, "errorerror");
    if (error) {
      // message.error("internal server error");
    }
    return error?.response;
  }
};

export const PUT = async (service, url, body, options) => {
  try {
    let result = await axiosInstances[service].put(url, body, options);
    return result;
  } catch (error) {
    return error?.response;
  }
};

export const PATCH = async (service, url, body, options) => {
  try {
    let result = await axiosInstances[service].patch(url, body, options);
    return result;
  } catch (error) {
    return error?.response;
  }
};

export default axiosInstances;